// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  number: __t.u8(),
  title: __t.string(),
  goal: __t.string(),
  summary: __t.string(),
  state: __t.u8(),
  scene: __t.byteArray(),
  jobId: __t.u64().name("job_id"),
  tries: __t.u8(),
  met: __t.u8(),
  missed: __t.u8(),
  openedWeek: __t.u64().name("opened_week"),
  openedAt: __t.timestamp().name("opened_at"),
});
